import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";

const SchedulePage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const HEADER_HEIGHT = 84;
  return (
    <Box
      sx={{
        width: "100%",
        height: `calc(100vh - ${HEADER_HEIGHT}px)`,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: isMobile
          ? "transparent"
          : theme.palette.background.default,
        p: 0,
        mt: `${HEADER_HEIGHT}px`,
      }}
    >
      <Box
        sx={{
          width: isMobile ? "100%" : "70%",
          height: "100%",
          boxShadow: isMobile ? "none" : "0 0 20px rgba(0,0,0,0.8)",
          borderRadius: isMobile ? 0 : "12px",
          overflow: "hidden",
        }}
      >
        <iframe
          src="https://api.leadconnectorhq.com/widget/booking/pvSPIagh7QDeGS6U9rxB"
          style={{ border: "none", width: "100%", height: "100%" }}
          title="Schedule a Call"
        />
      </Box>
    </Box>
  );
};

export default SchedulePage;
